const property = {
  property: {
    disclaimer: {
      heading: 'Disclaimer & advertisement information',
      reference: 'Reference: {{ref}}',
      advertiserFallback: 'the advertiser',
      body:
        'The information on this page is a property advertisement provided and maintained by the advertiser ({{advertiser}}). Safaqat24 makes no warranty as to the accuracy or completeness of this advertisement or any linked information, has no control over its content, and it does not constitute an offer, a contract, or official property particulars. Contact the advertiser directly to verify any detail - including the property’s advertising licence and any documents available under Saudi real-estate regulations - before acting or making any payment.',
      rega:
        'Real-estate advertisements in Saudi Arabia must carry a valid advertising licence issued through the General Authority for Real Estate (REGA).',
      adLicense: 'Advertising licence no.: {{number}}',
      linksLabel: 'See our full',
      termsLink: 'Terms of Use',
      falLink: 'FAL disclaimer',
      footnoteData:
        'Travel times, nearby places, neighbourhood and any market figures shown are indicative only, are based on third-party sources (including Google), and may change. Confirm independently before relying on them.',
      footnoteMap: 'Map data © Google.',
      safety: {
        title: 'Staying safe when searching for property',
        body:
          'Never transfer money or sign any document before you’ve verified the property, the advertiser, and its advertising licence in person. If something looks wrong, report the listing.',
        },
    },
    loading: {
      title: 'Loading property details...',
    },
    empty: {
      title: 'Property not found',
      description: 'The property you\'re looking for was removed or is temporarily unavailable.',
      cta: 'Browse listings',
    },
    header: {
      back: 'Back to results',
      save: 'Save',
      share: 'Share',
      priceAccessible: '{{value}} {{currency}}',
      pricePerSqm: '{{value}} / {{unit}}',
      pricePerSqmAccessible: '{{value}} {{currency}} per {{unit}}',
      reviewsLink: '({{count}} resident review)',
      reviewsLink_other: '({{count}} resident reviews)',
      areaScoreLabel: 'Area score',
      // Under a yearly rent: "About ⃁ 7,500 a month".
      monthlyLead: 'About',
      monthlyTail: 'a month',
      monthlyAccessible: 'About {{value}} Saudi riyals a month',
      listedOn: 'Listed on {{date}}',
      views: '{{formatted}} view',
      views_other: '{{formatted}} views',
    },
    badges: {
      hot: 'Most requested',
      mostLiked: 'Most liked',
      mostViewed: 'Most viewed',
      new: 'New',
      featured: 'Featured',
    },
    gallery: {
      photoCount: '{{count}} photo',
      photoCount_other: '{{count}} photos',
      virtualTour: 'Virtual tour',
      tabs: { images: 'Images', videos: 'Videos', floorPlan: 'Floor Plan', virtualTour: 'Virtual Tour' },
      videoUnavailable: 'Video unavailable',
      tourComingSoon: 'Virtual tour coming soon',
      markFloorPlan: 'Set as floor plan',
      isFloorPlan: 'Floor plan',
      videoLinkLabel: 'Video link',
      videoLinkPlaceholder: 'https://youtube.com/...',
    },
    status: {
      available: 'Available',
      pending: 'Under Negotiation',
      sold: 'Sold',
      rented: 'Rented',
    },
    metrics: {
      bedrooms: {
        label: 'Bedrooms',
        subtitle: '{{formatted}} bedroom',
        subtitle_other: '{{formatted}} bedrooms',
      },
      bathrooms: {
        label: 'Bathrooms',
        subtitle: '{{formatted}} bathroom',
        subtitle_other: '{{formatted}} bathrooms',
      },
      area: {
        label: 'Total area',
        subtitle: '{{value}} {{unit}}',
      },
      parking: {
        label: 'Parking',
        subtitle: '{{formatted}} space',
        subtitle_other: '{{formatted}} spaces',
      },
      yearBuilt: {
        label: 'Year built',
        subtitle: '{{value}}',
      },
    },
    sections: {
      details: 'Property Details',
      description: 'Description',
      features: 'Features & Amenities',
      propertyFeatures: 'Property features',
      amenities: 'Amenities',
      utilities: 'Utilities included',
      location: 'Location',
      contact: 'Contact Agent',
      info: 'Property Information',
    },
    propertyFeatures: {
      parking: 'Parking',
      coveredParking: 'Shaded parking for {{count}} vehicles',
      coveredParking_one: 'Shaded parking for {{count}} vehicle',
      coveredParking_other: 'Shaded parking for {{count}} vehicles',
      petFriendly: 'Pet friendly',
      furnished: 'Furnished',
    },
    utilities: {
      title: 'Utilities Included',
    },
    location: {
      fullAddress: '{{address}}, {{city}}, {{state}} {{zip}}',
      openMaps: 'Open in Google Maps',
    },
    contact: {
      agentTitle: 'Licensed Agent',
      scheduleButton: 'Schedule Viewing',
      contactButton: 'Contact Agent',
      sendEnquiry: 'Send Enquiry',
      enquiryMessage: "Hi, I'm interested in this property: {{title}}",
      scheduleMessage: 'Viewing request received. Our team will contact you shortly.',
      verifiedAgent: 'Verified agent',
      avgResponse: 'Avg. response: within an hour',
      callNow: 'Call now',
      whatsapp: 'WhatsApp',
      requestDetails: 'Request details',
      authPrompt: {
        title: 'Sign in to contact this broker',
        message: 'Create a free account or sign in to call, message, or email the broker about this property.',
        signIn: 'Sign in',
        cancel: 'Cancel',
      },
    },
    neighborhood: {
      title: 'Neighbourhood',
      caption: 'Based on amenities reported in this listing',
      captionNearby: 'Based on real places near this property',
      empty: 'Neighbourhood details not available yet',
      overall: 'Area score',
      // District-wide composite (nightly job over the whole district's market) —
      // a different scope from the nearby-services score around this property.
      districtScoreLabel: 'Overall district score',
      districtScoreCaption: 'From the district-wide market data - updated daily',
      nearbyServicesTitle: 'Services near this property',
      // Opens the rest of the area: the services in detail, the location record, sale prices and rents.
      showMore: 'More about the area',
      showLess: 'Show less',
      factors: {
        schools: 'Schools & education',
        services: 'Shopping & services',
        healthcare: 'Healthcare',
        transport: 'Transport & access',
        religious: 'Mosques',
      },
    },
    landmarks: {
      title: 'Notable nearby',
      fromLabel: '{{distance}} km from {{name}}',
      greatToVisit: 'Great place to visit',
    },
    nearby: {
      title: 'Location & Nearby Places',
      openMap: 'Open map',
      showAll: 'Show all ({{count}} places)',
      showLess: 'Show less',
    },
    travel: {
      title: 'How far from your daily places?',
      subtitle: 'Add your work or kids\' school to see the driving time from this property.',
      placeholder: 'e.g. My office in Al Rawdah district...',
      add: 'Add place',
      byCar: '~{{minutes}} min by car',
      byCarHours: '~{{hours}}h {{minutes}}m by car',
      remove: 'Remove {{name}}',
      unavailable: 'Travel time unavailable',
      savedToAccount: 'Saved to your account',
      savedLocally: 'Saved on this device - sign in to save it to your account',
    },
    similar: {
      title: 'Similar properties',
      sameAgentTitle: 'Similar properties from the same agent',
      viewMore: 'View more',
      rooms: '{{formatted}} room',
      rooms_other: '{{formatted}} rooms',
      badges: {
        hot: 'Most requested',
        featured: 'Featured',
        sameDistrict: 'Same district',
        new: 'New',
      },
    },
    form: {
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Email address',
      phonePlaceholder: 'Phone number',
      messagePlaceholder: 'Additional details (optional)',
      submit: 'Send Message',
      replyTimeNote: 'We will be in touch within 1 to 5 working days.',
      successMessage: 'Your message has been sent. We will be in touch within 1 to 5 working days.',
    },
    info: {
      labels: {
        id: 'Property ID',
        type: 'Property type',
        yearBuilt: 'Year built',
        status: 'Status',
        listed: 'Listed',
        updated: 'Last updated',
        adNumber: 'Ad number',
      },
    },
    properties: {
      'ksa-riyadh-01': {
        title: 'Panoramic Villa Overlooking Jeddah Park',
        address: 'King Abdullah Road',
        city: 'Jeddah',
        state: 'Jeddah Province',
        description:
          'A five-bedroom villa with double-height living spaces, floor-to-ceiling glazing, a private cinema, and landscaped outdoor terraces that frame uninterrupted skyline views of Jeddah Park.',
      amenities: [
        'Infinity-edge pool with cabana',
        'Private cinema lounge',
        'Smart home automation',
        'Roof terrace with skyline views',
        'Custom chef\'s kitchen',
        'Dedicated wellness suite',
        'Shaded parking canopies for four vehicles',
      ],
        utilities: ['Electricity', 'Water', 'High-speed internet'],
        agentName: 'Sara Al Saud',
        agentTitle: 'Senior Property Advisor',
      },
      'ksa-jeddah-02': {
        title: 'Palm-Framed Seafront Residence in Jeddah',
        address: 'Corniche Road, North Obhur',
        city: 'Jeddah',
        state: 'Makkah Province',
        description:
          'A contemporary waterfront apartment with sweeping Red Sea views, expansive terraces, and curated interiors that blend resort elegance with city convenience.',
      amenities: [
        'Private beach access',
        'Marina-view balcony',
        'Resort-style pool deck',
        'Residents fitness club',
        'On-site concierge services',
        'Secure underground parking',
        'Covered parking pergolas for two cars',
      ],
        utilities: ['Electricity', 'Water', 'High-speed internet', 'District cooling'],
        agentName: 'Mohammed Bawazeer',
        agentTitle: 'Luxury Leasing Specialist',
      },
      'ksa-dammam-03': {
        title: 'Contemporary Family Home in Dammam Heights',
        address: 'Prince Nayef Road',
        city: 'Dammam',
        state: 'Eastern Province',
        description:
          'A modern four-bedroom townhouse carefully planned for family life, combining airy double living rooms, a landscaped courtyard, and seamless access to the region\'s new business hubs.',
      amenities: [
        'Family garden courtyard',
        'Two-car private garage',
        'Separate maid\'s suite',
        'Community clubhouse access',
        'Children\'s play zone nearby',
        'Energy-efficient glazing',
        'Sun-shaded carport for three vehicles',
      ],
        utilities: ['Electricity', 'Water', 'Gas'],
        agentName: 'Layan Almutairi',
        agentTitle: 'Residential Consultant',
      },
      'ksa-riyadh-04': {
        title: 'Skyview Studio in King Abdullah Financial District',
        address: 'King Abdullah Financial District',
        city: 'Jeddah',
        state: 'Jeddah Province',
        description:
          'An elevated studio residence with panoramic city views, custom joinery, and effortless access to KAFD\'s dining, retail, and business addresses.',
      amenities: [
        'Panoramic fitness studio',
        'Resident lounge and co-working',
        '24/7 concierge services',
        'Sky garden terrace',
        'Secure parking bay',
        'Integrated storage solutions',
        'Canopied parking bay with sun sails',
      ],
        utilities: ['Electricity', 'Water', 'High-speed internet'],
        agentName: 'Ahmed Aldosari',
        agentTitle: 'Urban Leasing Advisor',
      },
    },
  },
};

export default property;


